import { trackItemListImpressionViewed } from '@slickdeals/web-instrumentation';
export const CONTAINER_TYPES = {
    feed: 'feed',
    carousel: 'carousel',
    sidebar: 'sidebar',
    modal: 'modal',
    popover: 'popover',
};
const viewedDealIdsMap = new Map();
const getNewViewedDealIdsSet = (containerName) => {
    const set = new Set();
    viewedDealIdsMap.set(containerName, set);
    return set;
};
export const initViewableImpressions = (container, selectors, containerData, deals, containerType) => {
    let dealsList = deals;
    let containerDataLocal = containerData;
    const visibleDeals = new Set();
    let timer = null;
    let observer = null;
    const trackVisibleDeals = () => {
        if (visibleDeals.size === 0) {
            return;
        }
        const viewedDealIds = viewedDealIdsMap.get(containerDataLocal.containerName) ||
            getNewViewedDealIdsSet(containerDataLocal.containerName);
        const visible = Array.from(visibleDeals)
            .map((dealEl) => {
            const uniqueId = dealEl.getAttribute('data-uniqueid');
            if (!uniqueId || viewedDealIds.has(uniqueId)) {
                return null;
            }
            const index = dealsList.findIndex((d) => d.uniqueId === uniqueId);
            if (index === -1) {
                return null;
            }
            viewedDealIds.add(uniqueId);
            return Object.assign(Object.assign({}, dealsList[index]), { itemIndex: index + 1 });
        })
            .filter((d) => d !== null);
        if (visible.length > 0) {
            trackItemListImpressionViewed({
                containerName: containerDataLocal.containerName,
                containerId: containerDataLocal.containerId || '',
                containerType: CONTAINER_TYPES[containerType],
                contentLayoutRender: containerDataLocal.contentLayoutRender,
            }, visible);
        }
    };
    const debouncedTrackViewable = () => {
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(() => {
            trackVisibleDeals();
            timer = null;
        }, 1000);
    };
    const observe = (addListeners) => {
        if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
            return;
        }
        observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                const isViewable = entry.isIntersecting && entry.intersectionRatio >= 0.5;
                if (isViewable) {
                    visibleDeals.add(entry.target);
                }
                else {
                    visibleDeals.delete(entry.target);
                }
            });
            debouncedTrackViewable();
        }, { threshold: 0.5 });
        selectors.forEach((selector) => {
            container.querySelectorAll(selector).forEach((deal) => observer === null || observer === void 0 ? void 0 : observer.observe(deal));
        });
        if (addListeners) {
            window.addEventListener('scroll', debouncedTrackViewable, { passive: true });
            window.addEventListener('resize', debouncedTrackViewable, { passive: true });
        }
    };
    const resetViewableImpressions = (newContainerData, newDeals) => {
        containerDataLocal = newContainerData;
        dealsList = newDeals;
        observer === null || observer === void 0 ? void 0 : observer.disconnect();
        visibleDeals.clear();
        observe(false);
        trackVisibleDeals();
    };
    observe(true);
    return {
        trackVisibleDeals,
        resetViewableImpressions,
    };
};
